import { Link } from 'react-router-dom';

const legalLinks = [
  { to: '/user-agreement', label: 'Пользовательское соглашение' },
  { to: '/privacy-policy', label: 'Политика обработки персональных данных' },
  { to: '/payment-info', label: 'Порядок проведения оплаты и безопасность' },
  { to: '/contacts', label: 'Контакты' },
];

export function Footer() {
  return (
    <footer className="border-t border-white/5 bg-eol-bg">
      <div className="mx-auto max-w-7xl px-6 py-8 lg:px-12">
        <div className="grid gap-6 md:grid-cols-[1fr_auto]">
          <div className="text-sm text-eol-desc space-y-1">
            <p>
              © {new Date().getFullYear()}{' '}
              <span className="text-eol-white font-semibold">EOL</span>. Все права защищены.
            </p>
            <p>Сервер не связан с Minecraft, Mojang или Microsoft.</p>
          </div>

          <nav className="flex flex-col gap-2 text-sm text-eol-desc md:items-end">
            {legalLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="hover:text-eol-white transition"
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}
